// Dependency
import React from "react"
import { graphql } from "gatsby"
import { useStoryblokState } from "gatsby-source-storyblok"
import DynamicComponent from "../helpers/storyblok/dynamicComponent"
import { checkBackgroundColor } from "../helpers/checkBackgroundColor"
import SAMPLE_CONTENT from "../assets/sample.json"

// Internationalization
// import { useTranslation } from "react-i18next"

// Components
import { SEO } from "../components/seo"
import Breadcrumbs from "../components/general/breadcrumbs/breadcrumbs"

const Page = ({ data, pageContext }) => {
  let story = data.storyblokEntry
  story = useStoryblokState(story)
  const bgColor = checkBackgroundColor(
    pageContext?.variables?.variable?.product?.backgroundColor
  )

  const components = story.content.sections.map(blok => {
    blok["bgColor"] = bgColor
    return <DynamicComponent blok={blok} key={blok._uid} />
  })

  return (
    <>
      {story.content.showBreadcrumbs ? (
        <div className="breadcrumbs--page">
          <Breadcrumbs breadTitle={story.content.title} />
        </div>
      ) : (
        ""
      )}

      {components}
    </>
  )
}

export default Page

export function Head(data) {
  const content = data.data.storyblokEntry.content
  if (content) {
    const seo =
      typeof content === "string" ? JSON.parse(content)?.SEO : content?.SEO
    if (seo) return <SEO title={seo?.title} description={seo?.description} />
  }
}

export const query = graphql`
  query PageQuery($full_slug: String!) {
    storyblokEntry(full_slug: { eq: $full_slug }) {
      ...StoryEntry
    }
  }
`
